"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestTimeOffsWorkspace = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const query_1 = __importDefault(require("./query"));
const WORKSPACE_TIMEOFFS_QUERY = (0, graphql_tag_1.default) `query TimeOffsWorkspaceQuery (
  $workspace: ID!,
  $period: PeriodInput!
  $categoryIds: [String!],
  $users: [ID!]
) {
  workspace (
    id: $workspace
  ) {
    timeOffs (
      period: $period
      categoryIds: $categoryIds
      users: $users
    ) ${query_1.default.TIME_OFF}
  }
}`;
const requestTimeOffsWorkspace = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(WORKSPACE_TIMEOFFS_QUERY, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.workspace.timeOffs;
};
exports.requestTimeOffsWorkspace = requestTimeOffsWorkspace;
exports.default = exports.requestTimeOffsWorkspace;
